module.exports = __webpack_public_path__ + "static/media/bg2.2c8fd7c6.jpg";